// extracted by css-extract-rspack-plugin
export default {"content":"content-HUE8Zw"};